import SanitationEntries from "../docs-archive-elements/SanitationEntries";
export default function SanitationDetails() {
    return (
      <div>
            <div className="general-bg bg-image">


<div className="gap-spacer"></div>
<div className="page-title top-cap-outlines">
    <h2>Sanitation</h2>
</div>

{/*End Large Image Space*/}
{/*Start Main Content*/}
<div className="content-fluid">

    <div className="mb-960-center-container mid-side-outlines">
        {/*Full Width Element*/}
        <div className="mb-960-col-50p">
            <div className="left-right-padding-1em">
                <h4>Waste Collection</h4>
                <p>Choose from the options below for information related to all types of waste collection provided in Morrisville Borough</p>

                <div className="container accordion-container">
                    <div className="accordion" id="sanitationStandard">
                        {/* Item Start */}
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSanitationStandard">
                                    <div>
                                        <i className="fa-solid fa-trash-can fa-2xl feature-icon af-icon"></i>
                                    </div>

                                    <div><b>Standard Collection</b></div>
                                </button>
                            </h2>
                            <div id="collapseSanitationStandard" className="accordion-collapse collapse" data-bs-parent="sanitationStandard">
                                <div className="accordion-body">
                                    <h5>Standard Collection</h5>
                                    <ul>
                                        <li>Trash is collected in Morrisville Borough on MONDAY &amp; THURSDAY</li>
                                        <li>Trash can not be placed at the curb earlier than 6:00 p.m. the day before collection</li>
                                    </ul>
                                    <h5>Holiday Collection Schedule</h5>
                                    <ul>
                                        <li>The six (6) holidays that impact trash &amp; recycling collection are New Years Day, Memorial Day, Independence Day, Labor Day, Thanksgiving Day, and Christmas Day</li>
                                        <li>All pickup days will be delayed by one day during any holiday week
                                            For example, a Monday holiday will be a Tuesday pickup
                                            and a Thursday holiday would be a Friday pickup</li>
                                    </ul>
                                    <h5>Purchase A Trash Or Recycling Bin</h5>
                                    <ul>
                                        <li>Residents may contact Republic Services directly, at 610-265-6337, to purchase 96-gallon trash and/or recycling bins and have them delivered to their residence. Cost is $60/per bin, paid at the time of order &amp;
                                            will be delivered in 5 business days.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/*Item End*/}
                        {/* Item Start */}
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSanitationRecycling">
                                    <div>
                                        <i className="fa-solid fa-recycle fa-2xl feature-icon af-icon"></i>
                                    </div>

                                    <div><b>Recycling</b></div>
                                </button>
                            </h2>
                            <div id="collapseSanitationRecycling" className="accordion-collapse collapse" data-bs-parent="sanitationStandard">
                                <div className="accordion-body">
                                    <h5>Recycling</h5>
                                    <ul>
                                        <li>Recycling is collected in Morrisville Borough on THURSDAY</li>
                                        <li>Recycling can not be placed at the curb earlier than 6:00 p.m. the day before collection
                                        </li>
                                    </ul>
                                    <h5>Holiday Collection Schedule</h5>
                                    <ul>
                                        <li>The six (6) holidays that impact trash &amp; recycling collection are New Years Day, Memorial Day, Independence Day, Labor Day, Thanksgiving Day, and Christmas Day</li>
                                        <li>All pickup days will be delayed by one day during any holiday week
                                            For example, a Monday holiday will be a Tuesday pickup
                                            and a Thursday holiday would be a Friday pickup</li>
                                    </ul>
                                    <h5>What Can Be Recycled</h5>
                                    <ul>
                                        <li>Plastics - #1 thru #7 (look for the number inside the recycling arrows on product)</li>
                                        <li>Metal Cans, Aluminum Foil &amp; Pans</li>
                                        <li>Paper, Cardboard, Newspapers &amp; Magazines</li>
                                        <li>Paper Food Containers (ex: egg cartons, cereal boxes, ice cream cartons)</li>
                                    </ul>
                                    <h5>DO NOT Put these items in your Recycling Bin</h5>
                                    <ul>
                                        <li>Plastics without numbers (ex: bags &amp; food wrappers, straws, to-go lids)</li>
                                        <li>Food or liquid waste INCLUDING grease</li>
                                        <li>Construction debris &amp; scrap metals</li>
                                        <li>Electronics, cables or batteries</li>
                                        <li>Hazardous / Bio-hazardous Waste</li>
                                        <li>Ceramics (including dishes &amp; mirrors)</li>
                                        <li>Light bulbs &amp; holiday decorations</li>
                                        <li>Diapers, tissues, clothes, shoes or toys</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/*Item End*/}

                        {/* Item Start */}
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSanitationBulk">
                                    <div>
                                        <i className="fa-solid fa-couch fa-2xl feature-icon af-icon"></i>
                                    </div>

                                    <div><b>Bulk Waste</b></div>
                                </button>
                            </h2>
                            <div id="collapseSanitationBulk" className="accordion-collapse collapse" data-bs-parent="sanitationStandard">
                                <div className="accordion-body">
                                    <h5>Bulk Waste</h5>
                                    <ul>
                                        <li>A single bulk item may be placed out for collection on MONDAY &amp; THURSDAY.</li>
                                        <li>Examples of bulk items
                                            <ul>
                                                <li>Carpets (must be cut into sections no longer than 3' and bundled)</li>
                                                <li>Mattresses &amp; Box Springs (must be wrapped in plastic)</li>
                                                <li>Household furnishings</li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <h5>Appliances</h5>
                                    <ul>
                                        <li>No appliances will be collected without prior notification
                                        </li>
                                        <li>Residents can call Republic Services at 610-265-6337 to schedule pickup</li>
                                        <li>Examples of appliances:
                                            <ul>
                                                <li>Refrigerators / Freezers</li>
                                                <li>Air conditioners</li>
                                                <li>Stoves</li>
                                                <li>Washers / Dryers</li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <h4>NO CONSTRUCTION MATERIALS WILL BE COLLECTED</h4>
                                </div>
                            </div>
                        </div>
                        {/*Item End*/}

                        {/* Item Start */}
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSanitationYard">
                                    <div>
                                        <i className="fa-solid fa-tree fa-2xl feature-icon af-icon"></i>
                                    </div>

                                    <div><b>Yard Waste</b></div>
                                </button>
                            </h2>
                            <div id="collapseSanitationYard" className="accordion-collapse collapse" data-bs-parent="sanitationStandard">
                                <div className="accordion-body">
                                    <h5>Leaf Drop-Off</h5>
                                    <ul>
                                        <li>Residents can utilize the Morrisville Borough Leaf Drop-off each Fall, located at Delaware &amp; Riverview Avenues</li>
                                        <li>Dates &amp; Times are limited. During the season, this info will be posted on the Borough's website, social media, and TV channel. Contact Borough Hall for additional assistance.<br/>
                                            
                                                {/*
                                        <p>Leaf Drop Off Opens Nov. 9th</p>
                                        <p>Mon-Fri 7:00 a.m. to 3:00 p.m.<br/>Sat. &amp; Sun. 8:00 a.m. to 2:00 p.m.
                                        <p>Drop Off Site Closes for Season December 15, 2024</p>
*/}

                                        </li>
                                    </ul>
                                    <h5>Leaf Collection</h5>
                                    <ul>
                                        <li>Leaves must be placed in paper bags or trash cans to be collected. NO PLASTIC ACCEPTED.</li>
                                        <li>Leaves can be placed out for collection on regular trash collection days
                                        </li>
                                    </ul>
                                    <h5>Yard Waste (branches, shrubs, etc.)</h5>
                                    <ul>
                                        <li>Yard waste can be put up for collection on regular trash collection days</li>
                                        <li>All items must be cut into sections no longer than 3’ and securely bundled</li>
                                        <li>Yard waste does not count as a bulk item</li>
                                    </ul>
                                    <h5>DO NOT RAKE OR BLOW LEAVES TO CURBSIDE</h5>
                                </div>
                            </div>
                        </div>
                        {/*Item End*/}
                        {/* Item Start */}
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSanitationElectronics">
                                    <div>
                                        <i className="fa-solid fa-desktop fa-2xl feature-icon af-icon"></i>
                                    </div>

                                    <div><b>Electronic Waste</b></div>
                                </button>
                            </h2>
                            <div id="collapseSanitationElectronics" className="accordion-collapse collapse" data-bs-parent="sanitationStandard">
                                <div className="accordion-body">
                                    
                                        <h5>Electronics are NOT eligible for curbside collection</h5>
                                        <ul>
                                            <li>The Covered Device Recycling Act 108 (CDRA) prohibits the following electronic devices from disposal at DEP permitted solid waste landfills:
                                                <ul>
                                                    <li>Desktop &amp; Laptop Computers</li>
                                                    <li>Computer Monitors</li>
                                                    <li>Computer Peripherals (ex: printers, scanners, external drives)</li>
                                                    <li>Televisions</li>
                                                </ul>
                                            </li>
                                            <li><b>Should any of these items be at curbside they will be tagged as non-collectible</b></li>
                                        </ul>

                                        <h5>See local retailers for disposal or call for further details</h5>
                                        <ul>
                                            <li>PA DEP Recycling Hotline: 1-800-346-4242
                                            </li>
                                            <li>Bucks Co. Planning Commission: 215-345-3400
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            
                            {/*Item End*/}


                        </div>
                    </div>
                </div>
                {/*Accordian End*/}
                <h4>Sanitation Fees</h4>
                <p>Sanitation fees for trash collection are included in the County/Borough tax bills. County/Borough tax bills are mailed out for March 1st delivery each year. </p>
                <p>
                    The fee for collection and disposal of refuse from residential properties is $423.00 per year, per dwelling unit.</p>
                <p>
                    The fee for collection and disposal of refuse from commercial properties is $1,360.00 per year, per commercial unit.</p>
                <p>
                    The Sanitation fees are billed to the owner listed on the recorded deed for the property.</p>

            </div>
        </div>

        <div className="mb-960-col-50p">
            <div className="left-right-padding-1em">
                <h4>Service-Related Issues</h4>
                <p>
                    For any service-related issues with trash or recycling, please contact REPUBLIC SERVICERS Customer Call Center at <a href="tel:6102656337"><i className="fa-solid fa-phone"></i>&nbsp;610-265-6337</a>
                </p>
                <h4>Related Documents</h4>
                <SanitationEntries />

            </div>






        </div>
    </div>


</div>
<div className="page-footer bottom-cap-outlines">&nbsp;</div>
<div className="gap-spacer"></div>
<div className="gap-spacer"></div>
</div>




      </div>
    )
}
